getObservableFromLink